import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PlanSection } from '../PlanSection/PlanSection';
import { PlatformBlock } from './components/PlatformBlock';
import { PLATFORMS } from './constants';

export interface PlatformsSectionProps {
  isOpen?: boolean;
}

export function PlatformsSection({ isOpen = false }: PlatformsSectionProps) {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  const { t: tNames } = useTranslation('names');

  const { control } = useFormContext();

  return (
    <PlanSection
      title={t('planWizard.sections.platforms.title')}
      description={t('planWizard.sections.platforms.description')}
      isOpen={isOpen}
    >
      <Controller
        name="platforms"
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <div className="flex flex-wrap gap-lg">
            {PLATFORMS.map((item) => {
              const currentValues = field.value || [];
              const isSelected = currentValues.includes(item.id);

              return (
                <PlatformBlock
                  key={item.id}
                  data-testid={`platform-block-${item.id}`}
                  data-selected={isSelected}
                  iconName={item.icon}
                  title={tNames(item.titleKey)}
                  isSelected={isSelected}
                  onClick={() => {
                    const newValues = isSelected
                      ? currentValues.filter((id: string) => id !== item.id)
                      : [...currentValues, item.id];

                    field.onChange(newValues);
                  }}
                />
              );
            })}
          </div>
        )}
      />
    </PlanSection>
  );
}

PlatformsSection.displayName = 'PlatformsSection';
